//components
import BottomButton from '../common/BottomButton'
//hooks
import useConnectGmail from 'hooks/useGmailConnect'
//types
import { ConnectGmailButtonProps } from 'types'

export const ConnectGmailButton = ({ hideModal }: ConnectGmailButtonProps) => {
  const { requestGmailAccess } = useConnectGmail(hideModal)

  return (
    <>
      <BottomButton style={{ margin: '10px 0' }} handleClick={requestGmailAccess}>
        Connect Email
      </BottomButton>
    </>
  )
}
